import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import UserAvatarPopover from '../AvatarPopover';
import { ResourceType } from '../../types/resource';
import { BiData } from '@wix/da-bi/pkg/events';
import { isGroup } from '../helpers';
export const UserLinkPopover = ({ user, className, relatedItemBiData, biData, children })=>{
    return /*#__PURE__*/ React.createElement(UserAvatarPopover, {
        username: user.username,
        className: className,
        relatedItemBiData: relatedItemBiData,
        biData: BiData(_object_spread({
            evid: 107,
            itemid: user.userId,
            typeid: isGroup(user) ? ResourceType.GROUP : ResourceType.USER
        }, biData))
    }, children);
};
UserLinkPopover.displayName = 'UserLinkPopover';
export default UserLinkPopover;
